export enum Environments {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

export enum Region {
  US = 'us',
  EU = 'eu',
  AU = 'au',
  LOCAL = 'local'
}

export const getRegionsForEnvironment = (env: Environments): Region[] => {
  switch (env) {
    default:
    case Environments.DEVELOPMENT: {
      return [Region.LOCAL];
    }
    case Environments.STAGING: {
      return [Region.EU];
    }
    case Environments.PRODUCTION: {
      return [Region.US, Region.EU, Region.AU];
    }
  }
};

export const TRIAL_REGIONS: { [k in Environments]: Region } = {
  [Environments.DEVELOPMENT]: Region.LOCAL,
  [Environments.STAGING]: Region.EU,
  [Environments.PRODUCTION]: Region.US
};

export const REGION_LABELS = {
  [Region.LOCAL]: 'Local',
  [Region.AU]: 'Australia',
  [Region.US]: 'United States',
  [Region.EU]: 'Europe'
};
